import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../../lib/errorHandler';
import useSnackBar from '../../../Redux/hooks/useSnackBar';
import FilterListIcon from '@mui/icons-material/FilterList';
import usePageLoader from '../../../Redux/hooks/usePageLoader';
import NoDataFound from '../../../Component/Common/NoDataFound';
import { standardDateFormat } from '../../../lib/standardDateFormat';
import StyledTableRow from '../../../Component/Common/StyledTableRow';
import IconBackground from '../../../Component/Common/IconBackground';
import StyledTableCell from '../../../Component/Common/StyledTableCell';
import CommonPagination from '../../../Component/Common/CommonPagination';
import { useCommonStyles } from '../../../utils';
import { Box, Button, Collapse, Fab, Grid, Tab, Table, TableBody, TableContainer, TableHead, Tabs, Typography, useTheme } from '@mui/material'
import AddUpdateLotNumber from '../../../Component/PurchaseEntry/LotNumber/AddUpdateLotNumber';
import { deleteLotNumber, getLotNumbers } from '../../../Redux/Actions/PurchaseEntry';
import { useConfirm } from 'material-ui-confirm';
import { useAppSelector } from '../../../Redux/app/hooks';
import CommonSearchField from '../../../Component/Common/CommonSearchField';
import { makeStyles } from 'tss-react/mui';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { BaseUrl, LOGIN_TOKEN } from '../../../ApiSetUp/AuthApi';
import localStoreUtil from '../../../ApiSetUp/localstore.util';
import axios from 'axios';

const useStyles = makeStyles()((theme) => ({
    customTabStyle: {
        "& .MuiTabs-flexContainer": {
            gap: "10px",
        },
        "& .MuiTab-root": {
            border: "1px solid",
            borderColor: "#00000033",
            backgroundColor: "transparent",
            minWidth: "40px",
            minHeight: "40px",
            borderRadius: "10px",
            padding: "10px 14px",
            fontFamily: "Satoshi-Light",
            color: "#131313"
        },
        "& .Mui-selected": {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            fontFamily: "Satoshi-Bold",
            backgroundColor: theme.palette.bgWhite.main
        },
        "& .MuiTabs-indicator": {
            display: "none"
        }
    },
}));


const lotNumberCategory = [
    { name: "Base Paper / Film", value: 1 },
    { name: "Chemical", value: 3 },
    { name: "Ink", value: 4 },
];

const LotNumberList = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const confirmDialogue = useConfirm();
    const { classes: muiClasses } = useStyles();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [listData, setListData] = useState({});
    const [isOpenAddUpdateLotNumber, setIsOpenAddUpdateLotNumber] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [uniqueReelId, setUniqueReelId] = useState();
    const [data, setData] = useState({})
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState({ name: "Base Paper / Film", value: 1 },);

    const [yearOptions, setYearOptions] = useState([]);
    const [selectedYear, setSelectedYear] = React.useState(null);
    const [searchValue, setSearchValue] = useState('');

    const [openRow, setOpenRow] = useState(null);
    // =============== Handler ===============
    let PerPage = 10
    const tabelHeader = ["SR.", "Lot.no","PO NUMBER", "VENDOR NAME", ...(activeTab?.value == 3 ? ["invoice Number"] : []), "DATE", "Action"]
    const subTabelHeader = ["Item Name", "Supply Quantity",]

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (e, p) => {
        setPage(p);
    };

    // ============= get Inventories API =============
    const _getLotNumber = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
            "category": activeTab?.value
        }
        response = await dispatch(getLotNumbers(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Delete Inventory Field API =============
    const _deletePurchaseOrder = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = {
            uniqueId: id
        }
        response = await dispatch(deleteLotNumber(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSnackBar("success", response?.payload?.message)
                _getLotNumber();
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    const _downloadExcel = async (id) => {
        try {
            setFullPageLoader(true);
            let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
            const response = await axios.post(
                `${BaseUrl}admin/downloadLotNumber`,
                { uniqueId: id || null },
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${login_token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (!response.data || response.data.size === 0) {
                console.error("Empty file received, check API response");
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `lot-list-${selectedYear?.id}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error fetching yearly totals:", error);
        } finally {
            setFullPageLoader(false);
        }
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (searchValue) {
            _getLotNumber();
        } else {
            _getLotNumber();
        }
    }, [page, searchValue, activeTab])
    
    useEffect(() => {
        setPage(1);
    }, [searchValue]);

    // useEffect(() => {
    //     const currentYear = new Date().getFullYear();
    //     const years = Array.from({ length: 5 }, (_, i) => {
    //         const startYear = currentYear - (i + 1);
    //         const endYear = startYear + 1;
    //         return {
    //             id: `${startYear}-${endYear.toString().slice(-2)}`,
    //             name: `${startYear}-${endYear.toString().slice(-2)}`,
    //         };
    //     });
    //     setYearOptions(years);
    //     setSelectedYear(years[0]);
    // }, []);
useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // 0 = Jan, 3 = Apr

    // Financial year starts in April
    const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;

    const years = Array.from({ length: 5 }, (_, i) => {
        const fyStart = startYear - i;
        const fyEnd = fyStart + 1;

        return {
            id: `${fyStart}-${fyEnd.toString().slice(-2)}`,
            name: `${fyStart}-${fyEnd.toString().slice(-2)}`
        };
    });

    setYearOptions(years);
    setSelectedYear(years[0]);
}, []);


    return (
        <>
            {isOpenAddUpdateLotNumber ?
                <AddUpdateLotNumber setSearchValue={setSearchValue} activeTab={activeTab} selectedYear={selectedYear} setSelectedYear={setSelectedYear} yearOptions={yearOptions} setUniqueReelId={setUniqueReelId} setIsEditMode={setIsEditMode} isEditMode={isEditMode} uniqueReelId={uniqueReelId} setIsOpenAddUpdateLotNumber={setIsOpenAddUpdateLotNumber} setData={setData} data={data} _getLotNumber={_getLotNumber} />
                :
                <Grid container spacing={2} padding={"25px"}>
                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Lot Number List</Typography>
                    </Grid>
                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                        <Tabs value={value} onChange={handleChange} className={muiClasses.customTabStyle}>
                            {lotNumberCategory.map((ele, index) => (
                                <Tab key={index} onClick={() => setActiveTab(ele)} label={ele.name} />
                            ))}
                        </Tabs>
                        <Box display={"flex"} gap={1} flexWrap={'wrap'}>
                            <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["Vendor Name", 'PO Number']} />
                            {/* <Button className={classes.cancelButton} startIcon={<FilterListIcon />}>Filters </Button> */}
                            {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenAddUpdateLotNumber(true)}>Add New Lot No.</Button>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                            <TableContainer>
                                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                    <TableHead>
                                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                            {tabelHeader?.map((ele) => {
                                                return (
                                                    <StyledTableCell>{ele}</StyledTableCell>
                                                )
                                            })}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listData?.response?.length > 0 ? (
                                            listData?.response?.map((row, index) => (
                                                <React.Fragment key={index}>
                                                    <StyledTableRow >
                                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                        <StyledTableCell> {row.lotNumber ? row.lotNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.poNumber ? row.poNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.vendorName ? row.vendorName : "NA"}</StyledTableCell>
                                                        {activeTab?.value == 3 &&
                                                            <StyledTableCell> {row.invoiceNumber ? row.invoiceNumber : "NA"}</StyledTableCell>
                                                        }
                                                        <StyledTableCell> {row?.createdAt && standardDateFormat(row?.createdAt)}</StyledTableCell> <StyledTableCell>
                                                            <Box display={"flex"} gap={1}>
                                                                {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"edit"} disabled={row.status === 1} onClick={() => { setUniqueReelId(row?.uniqueId); setIsOpenAddUpdateLotNumber(true); setIsEditMode(true) }} />
                                                                }
                                                                {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"download"} onClick={(e) => _downloadExcel(row?.uniqueId)} />
                                                                }
                                                                {getPermissionList?.editPermission?.includes('Purchase Entry') &&
                                                                    <IconBackground icon={"delete"} disabled={row.status === 1}
                                                                        onClick={(e) => {
                                                                            confirmDialogue({
                                                                                title: `Are you sure you want to delete?`,
                                                                            }).then(() => {
                                                                                _deletePurchaseOrder(row?.uniqueId)
                                                                            }).catch((err) => { console.error(err) });
                                                                        }}
                                                                    />
                                                                }
                                                                <Fab
                                                                    sx={{
                                                                        height: '36px',
                                                                        width: '36px',
                                                                        minHeight: "30px",
                                                                        backgroundColor: theme.palette.primary.main,
                                                                        boxShadow: "none",
                                                                        "&.MuiFab-root.Mui-disabled": {
                                                                            backgroundColor: 'transparent'
                                                                        },
                                                                        "&:hover": { backgroundColor: theme.palette.primary.main },
                                                                    }}
                                                                    onClick={() => { setOpenRow(index == openRow ? null : index) }}>
                                                                    {openRow === index ? <KeyboardArrowUpIcon sx={{ color: "#FFF" }} /> : <KeyboardArrowDownIcon sx={{ color: "#FFF" }} />}
                                                                </Fab>
                                                            </Box>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} style={{ padding: "0px 10px 0px 10px" }}>
                                                            <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                                                                <Box margin={1}>
                                                                    <Typography fontSize={'18px'} fontFamily={"Satoshi-Bold"} ml={1} mb={1}>
                                                                        All Items
                                                                    </Typography>
                                                                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                                                        <TableContainer>
                                                                            <Table>
                                                                                <TableHead>
                                                                                    <StyledTableRow isHeader>
                                                                                        {subTabelHeader?.map((ele) => {
                                                                                            return (
                                                                                                <StyledTableCell>{ele}</StyledTableCell>
                                                                                            )
                                                                                        })}
                                                                                    </StyledTableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {row?.peDetails?.purchaseOrder?.length > 0 ? (
                                                                                        row?.peDetails?.purchaseOrder?.map((subRow, subIndex) => (
                                                                                            <StyledTableRow key={subIndex}>
                                                                                                <StyledTableCell>
                                                                                                    <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "50px", textAlign: "center" }}>
                                                                                                        <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'}>{subRow?.itemName ? subRow?.itemName : "NA"}</Typography>
                                                                                                    </Box>
                                                                                                </StyledTableCell>
                                                                                                <StyledTableCell>{subRow.supplyQuantity}</StyledTableCell>

                                                                                            </StyledTableRow>
                                                                                        ))
                                                                                    ) : (
                                                                                        <StyledTableRow>
                                                                                            <StyledTableCell colSpan={12}>
                                                                                                <NoDataFound />
                                                                                            </StyledTableCell>
                                                                                        </StyledTableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Box>
                                                                </Box>
                                                            </Collapse>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={12}>
                                                    <NoDataFound />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <CommonPagination
                                totalCount={listData?.count}
                                count={Math.ceil(listData?.count / PerPage)}
                                itemsPerPage={PerPage}
                                page={page}
                                onChange={handleChangePage}
                            />
                        </Box>
                    </Grid>

                </Grid>
            }
        </>
    )
}

export default LotNumberList